<script>
import MapManager from '@/components(new)/UI/Maps/core/mapManager.js'

export default {
  props: {
    id: String,
    enableEdit: Boolean
  },
  data () {
    return {
      mapManager: null
    }
  },
  mounted () {
    if (!this.mapManager?.map) {
      this.mapManager = new MapManager(this.id, this.enableEdit)
    }
  },
  activated () {
    if (!this.mapManager?.map) {
      this.mapManager = new MapManager(this.id, this.enableEdit)
    }
  },
  expose: {
    mapManager: this.mapManager
  }
}
</script>

<template>
  <div class="sedap-base-map">
    <slot name="top" />
    <div class="sedap-base-map__map-container">
      <div :id="id" />
    </div>
    <slot name="bottom" />
  </div>
</template>

<style lang="scss">
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Maps/BaseMap/BaseMap.vue